import {Dispatch} from 'redux';

import AppState from '../../../reducers/AppState';

import StoryAggregation from '../../../../domain/value_objects/summary/StoryAggregation';

import NetEpisodeAggregationsRepository from '../../../../data/repositories/writer/summary/NetStoryAggregationsRepository';

export interface Option {
  from?: Date | undefined;
  to?: Date | undefined;
}

export default function action(
  id: number,
  options: Option = {},
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<StoryAggregation> {
  return async (
    dispatch: Dispatch<any>,
    getState: () => AppState,
  ): Promise<StoryAggregation> => {
    const repository = new NetEpisodeAggregationsRepository();
    const payload = await repository.find(id, options);
    return payload;
  };
}
